export default "__VITE_ASSET__DajkSY2k__ 100w";